import {
  Button,
  Form,
  PageHeader,
  Row,
  Breadcrumb,
  Popconfirm,
  Col,
  Input,
  message,
  Select,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { materialTypeService, stockIssueService } from "_services";

const UploadAsyCuda = ({ history }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [base64File, setBase64File] = useState(null);
  const [originalFileName, setOriginalFileName] = useState(null);
  const [error, setError] = useState(null);
  const [boms, setBoms] = useState([]);

  const [form] = Form.useForm();

  useEffect(() => {
    materialTypeService
      .getAllFinished()
      .then((x) => {
        setIsLoading(true);
        setBoms(x.content);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  },[]);

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);

        const payload = {
          base64FileString: base64File,
          originalFileName: originalFileName,
          finishProduct:{id:values.bom}
        };       
        
        stockIssueService
          .uploadAsyCudaFile(payload)
          .then((x) => {
            message.success("Successfully uploaded!");
            setIsLoading(false);
            history.push("/stock-issue");
          })
          .catch((error) => {
            setIsLoading(false);
            setError(error);
    
          });
      })
      .catch((error) => {
        message.error(`${error}`);
        console.log(error);
        
      });
  };

  const onCancel = () => {
    history.push("/stock-issue");
  };

  const onFileChange = (e) => {
    if (e.target.files[0]) {
      setOriginalFileName(e.target.files[0].name);
      let reader = new FileReader();
      reader.onload = function (e) {
        setBase64File(reader.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const getActionButtons = () => {
    let buttons = [];

    buttons.push(
      <Popconfirm
        title="Are you sure to add the changes?"
        onConfirm={handleFormSumbit}
        // onConfirm={() => {}}
        key="add-confirm"
      >
        <Button key="save" type="primary" htmlType="submit" loading={isLoading}>
          Upload
        </Button>
      </Popconfirm>
    );
    buttons.push(
      <Button key="cancel" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );

    return buttons;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/stock-issue">Stock-Issues</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>AsyCuda Import File Upload</Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <Spin tip="Loading..." spinning={isLoading}>
            <Form
              layout="vertical"
              form={form}
              name="form-create"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name="bom"
                    label="Choose BOM"
                    rules={[
                      {
                        required: true,
                        message: "Valid BOM required",
                      },
                    ]}
                    valuePropName="bom"
                  >
                    <Select onChange={()=>{}}
                      placeholder="Select a BOM"
                      >
                      {boms && boms.map((item)=><Select.Option value={item.id}>{item.name}</Select.Option>)}
                      
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name="file"
                    label="AsyCuda Import XML File"
                    rules={[
                      {
                        required: true,
                        message: "Valid XML file is required",
                      },
                    ]}
                    valuePropName="file"
                  >
                    <Input
                      type="file"
                      name="file"
                      onChange={onFileChange}
                      allowClear
                    />
                  </Form.Item>
                </Col>

                <Col span={12}></Col>
              </Row>
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
};

export default UploadAsyCuda;
